import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                水蜜桃视频
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              专注于水蜜桃种植、采摘、品鉴与美食制作的短视频内容平台，带你感受水蜜桃从花开到成熟的全过程。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/plantation" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  水蜜桃种植
                </Link>
              </li>
              <li>
                <Link to="/category/cuisine" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  水蜜桃美食
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2 text-sm text-background-50/60">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>hello@shuimitao-video.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>0571-8888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span>浙江省杭州市余杭区梦想小镇桃园路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2020-2026 水蜜桃视频 版权所有 | 浙ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-50/40 hover:text-background-50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-50/40 hover:text-background-50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="https://www.douyin.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-50/40 hover:text-background-50 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}